<!-- <div class="container">
  <div class="col-sm-12 pt-5 webview" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre questxt">
      Last question!
      <a
        style="color: #ed1976; text-decoration: underline"
        href="javascript:void(0);"
        (click)="getMonthsDetails()"
      >
        Click here</a
      >
      to let us estimate your usage
    </h1>
    <h1 class="text-center font-weight-normal-calibre mt-0 questxt">
      for the last 12 months or enter it below.
    </h1>
    <div class="row m-auto" id="form">
      <div class="col-sm-6 m-auto blocks3">
        <div
          class="col-sm-4 pl-2 float-label-control"
          *ngFor="let month of months | slice: 0:6; let i = index"
        >
          <input
            type="number"
            id="{{ month.month }}"
            min="1"
            class="valueinput floating-input monthrender"
            tabindex="i"
            [(ngModel)]="month.usage"
            (keyup)="onKey($event)"
            (ngModelChange)="enableButton(month.month)"
            appFourDigitDecimaNumber
            placeholder=""
            value="{{ month.monthValue }}"
          />
          <label class="floating-label"
            >{{ month.monthformat }} - {{ month.year }}</label
          >
          <font class="unitfont">kWh</font>
        </div>
      </div>
    </div>
    <div class="row m-auto" id="form">
      <div class="col-sm-6 m-auto blocks3">
        <div
          class="col-sm-4 pl-2 float-label-control"
          *ngFor="let month of months | slice: 6:12; let i = index"
        >
          <input
            type="number"
            id="{{ month.month }}"
            min="1"
            class="valueinput inputText monthrender"
            tabindex="i"
            [(ngModel)]="month.usage"
            (ngModelChange)="enableButton(month.month)"
            appFourDigitDecimaNumber
            placeholder=""
            value="{{ month.monthValue }}"
          /><label class="floating-label"
            >{{ month.monthformat }} - {{ month.year }}</label
          >
          <font class="unitfont">kWh</font>
        </div>
      </div>
    </div>

    <div *ngIf="showbutton" class="col-12 text-center">
      <a href="javascript:void(0);" (click)="next()" id="nextButton">
        <button
          class="btn next mr-2 ml-2 my-3 disabledButton font22"
          [ngClass]="{ sectbtn: user_bot }"
        >
          FINISH
        </button>
      </a>
    </div>
    
    <div  class="col-12 text-center">
      <a href="javascript:void(0);" (click)="next()" id="nextButton">
        <button
          class="btn next mr-2 ml-2 my-3  font22"
        
        >
          Next
        </button>
      </a>
    </div>
    <div class="mt-3">
      <div class="m-auto col-sm-4 col-md-6 col-xl-6 blockbg boxclr text-center">
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">ADVICE</p>
        <p class="text-center tipmes">{{ questionObj.tip }}</p>
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-4 pt-2 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0 mb-2">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box mt-3">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
      <p class="text-left actualqlargemsg mb-4">
        Enter actual usage below or
        <a
          style="color: #0055ff"
          href="javascript:void(0);"
          (click)="getMonthsDetails()"
        >
          click here </a
        >and have Eva estimate for you
      </p>
    </div>
  </div>
  <div class="row col-12 m-auto" id="form">
    <div
      class="form-group col-6 px-0 float-label-control"
      *ngFor="let month of months; let i = index"
    >
      <div class="col-12 pl-2 m-auto">
        <input
          type="tel"
          min="1"
          class="valueinput inputText monthrender"
          appFourDigitDecimaNumber
          [(ngModel)]="month.usage"
          id="{{ i }}"
          (ngModelChange)="enableButton(i)"
          placeholder=""
          (keydown)="goKey($event, i)"
          (keyup.enter)="next()"
        /><label class="floating-label"
          >{{ month.monthformat }} - {{ month.year }}</label
        >
        <font class="unitfont">kWh</font>
      </div>
    </div>
    <div class="col-12 text-center">
      <a href="javascript:void(0);" (click)="next()">
        <button
          class="btn mr-2 ml-2 my-3 disabledButton font20 px-4"
          [ngClass]="{ sectbtn: user_bot }"
        >
          FINISH
        </button>
      </a>
    </div>
    <div class="col-xl-6">
      <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
        <img
          src="assets/images/flash.png"
          class="mb-1"
          style="margin-left: 48%"
        />
        <p class="text-center tiphead">ADVICE</p>
        <p class="text-center tipmes">{{ questionObj.tip }}</p>
      </div>
    </div>
  </div>
</div>
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait for a few seconds...
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


 -->



 <div class="container col-sm-8 pt-5 webview text-center"  [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre questxt" *ngIf="!addAddressFlow">{{question}}</h1>
  <h1 class="text-center font-weight-normal-calibre mt-0 questxt pb-4">
    for the last 12 months?
  </h1>
  <div class="col-sm-12">
      <div class="d-flex  m-auto col-sm-6 col-md-6 col-xl-8">
          <div class="col-6 q-cards">
              <label class="card card-list pt-2 text-center d-inline-block pull-right" for="NewService">
                  <img src="{{ns_src}}" height="100px">
                  <div></div>
                  <label for="NewService">Enter Usage History</label>
                  <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
                      <input type='checkbox' class="custom-control-input" id="NewService" value='Enter Usage History'
                          [(ngModel)]="hgService.ns" name="service" (change)="getService($event)" />
                      <label class="custom-control-label" for="NewService"></label>
                  </div>
              </label>
          </div>
          <div class="col-6 q-cards">
              <label class="card card-list pt-2 text-center d-inline-block pull-left" for="SwitchingProviders">
                  <img src="{{sp_src}}" height="100px">
                  <div></div>
                  <label for="SwitchingProviders">Estimate For Me</label>
                  <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
                      <input type='checkbox' class="custom-control-input" id="SwitchingProviders" value='Estimate For Me'
                          [(ngModel)]="hgService.sp" name="service" (click)="getService($event)" />
                      <label class="custom-control-label" for="SwitchingProviders"></label>
                  </div>
              </label>
          </div>
      </div>
  </div>
  <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
  <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': isChecked}" (click)="next2();">Next</button>

  <div class="mt-3">
    <div class="m-auto col-sm-4 col-md-6 col-xl-6 blockbg boxclr text-center">
      <img src="assets/images/flash.png" class="mb-1" />
      <p class="text-center tiphead">ADVICE</p>
      <p class="text-center tipmes">{{ questionObj.tip }}</p>
    </div>
  </div>
</div>
<div class="container mobileview px-0 mb-4" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0 mt-5">
      <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
          <img style="width:100%;" src="assets/images/signimg.jpg" />
      </div>
      <div class="col-sm-9 col-9 px-0 my-auto" >
          <div class="arrow_box">
              <h1 class="questionMob text-left">{{question}}</h1>
              <!-- <h1 class="questionMob text-left">
                for the last 12 months?
              </h1> -->
          </div>
      </div>
  </div>
  <div class="row col-sm-12 m-auto" >
      <div class="d-flex mt-2">
          <div class="col-6 pl-0 box-shadow-none">
              <label class="card card-list text-center d-inline-block" for="UsageHistory_mob" style= "min-height: 156px;">
                  <img src="{{ns_src}}" width="45%">
                  <label for="UsageHistory_mob">Enter Usage History</label>
                  <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                      <input type='checkbox' class="custom-control-input" id="UsageHistory_mob"  value='Enter Usage History'
                          [(ngModel)]="hgService.ns" name="service" (change)="getService($event);"/>
                      <label class="custom-control-label" for="UsageHistory_mob"></label>
                  </div>
              </label>
          </div>
          <div class="col-6 pr-0 box-shadow-none">
              <label class="card card-list text-center d-inline-block" for="Estimate_mob" style= "min-height: 156px;">
                  <img src="{{sp_src}}" width="40%">
                  <label for="Estimate_mob">Estimate For Me</label>
                  <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                      <input type='checkbox' class="custom-control-input" id="Estimate_mob"  value='Estimate For Me'
                          [(ngModel)]="hgService.sp" name="service" (change)="getService($event);"/>
                      <label class="custom-control-label" for="Estimate_mob"></label>
                  </div>
              </label>
          </div>
      </div>
      
      <!-- <div class="col-12">
  <div class="custom-control custom-checkbox chkbox mb-2">            
          <input type='checkbox' class="custom-control-input" id="SwitchingProviders3" value='Switching Providers'
              [(ngModel)]="hgService.sp" name="service" (change)="getService($event)" />                        
              <label class="custom-control-label"  for="SwitchingProviders3">Label text</label>                   
      </div>
  </div> -->
      <!-- <div class="form-group">
          <input type='checkbox' value='New Service' [(ngModel)]="hgService.ns" name="service" (change)="getService($event);" />New
          service
      </div>
      <div class="form-group">
          <input type='checkbox' value='Switching Providers' [(ngModel)]="hgService.sp" name="service" (change)="getService($event);" />Switching
          Providers
      </div> -->
      <!-- <div class="text-center" style="width:100% !important;"> <p class="m-auto text-muted tapmsg">{{questionObj.chkboxtype}}</p></div>
      <div style="width:100% !important; text-align: right;">
          <div *ngIf="user_bot" class="ash_box mt-2" >
              <h1 class="ansMob" *ngIf ="service === 'New Service'">I want to establish New Service</h1>
              <h1 class="ansMob" *ngIf ="service === 'Switching Providers'">I want to Switch Providers</h1>
          </div>
      </div> -->
     
  </div>
  <br />
  <br />
  <div class="col-xl-6">
    <div class="m-auto col-sm-4 col-md-6 col-xl-6 blockbg boxclr text-center">
      <img src="assets/images/flash.png" class="mb-1" />
      <p class="text-center tiphead">ADVICE</p>
      <p class="text-center tipmes">{{ questionObj.tip }}</p>
    </div>
  </div>
</div>
<!-- <div class="btm-process webview">
  <div class="text-center">
      <span><img src="assets/images/active2.png"></span>
      <h5 class="clr333 processtxt">10% Completed</h5>
  </div>
</div> -->